import { render, staticRenderFns } from "./company-setting.vue?vue&type=template&id=761e734a&scoped=true&"
import script from "./company-setting.vue?vue&type=script&lang=js&"
export * from "./company-setting.vue?vue&type=script&lang=js&"
import style0 from "./company-setting.vue?vue&type=style&index=0&id=761e734a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761e734a",
  null
  
)

export default component.exports